$(function() {
  $('.attachment_file_field').on('change', function() {
    var maxFileNamesToDisplay = 3;

    // Building the content of the selected_files_label
    // Note that this.files is a FileList and not a regular array of files
    var fileNames = [...this.files].map(file => file.name);
    $('.selected_files_label').val(fileNames.length <= maxFileNamesToDisplay ? fileNames.join(", ") : `${fileNames.length} files selected`);
  })

  $('.faux-select-wrap .faux-select').on('click', function() {
    $(this).parent().addClass("faux-select-wrap-active");
  });

  $('.faux-select-wrap .faux-select').on('blur', function() {
    $(this).parent().removeClass("faux-select-wrap-active");
  });

  $('.faux-select-options__option').on('mousedown', function() {
    var value = $(this).text();
    
    $(this).siblings().removeClass("faux-select-options__option-active");
    $(this).addClass("faux-select-options__option-active");
    $(this).parent().parent().find(".faux-select span").removeClass('no-selection');
    $(this).parent().parent().find(".faux-select span").text(value);
    $(this).parent().parent().find("input").val(value);

    $(this).parent().parent().find("select option[value='" + value + "']").prop("selected", true);
    $(this).parent().parent().removeClass("faux-select-wrap-active");

    if ($(this).hasClass('advice-options')) {
      var otherDesiredOutcome = $(this).closest('.rd-form-row').find('.other-outcome');
      if (value == "Other") {
        otherDesiredOutcome.removeClass('dn')
      } else {
        otherDesiredOutcome.addClass('dn')
        otherDesiredOutcome.val('')
      }
    }
  });

  $('.master-form .faux-select-options__option').on('mousedown', function() {
    var data = $(this).data('form');
    $(".contact-form__master").hide();
    $("."+data).show();
    $("."+data).removeClass("form-lock");
  });
});
